import { Cookies } from 'react-cookie';

class CookieStorage {
    constructor() {
        this.cookies = new Cookies();
    }

    async setValue(key, value, options = {}) {
        this.cookies.set(key, value, {
            path: '/',
            secure: true,
            sameSite: 'strict',
            ...options,
        });
    }

    async getValue(key) {
        return this.cookies.get(key) || null;
    }

    async removeValue(key) {
        this.cookies.remove(key, { path: '/' });
    }
}

export default CookieStorage;
